import React from "react";
import { ArrowUpOutlined, AppstoreOutlined, SmileOutlined, EnvironmentOutlined, CarOutlined, QuestionCircleOutlined, UsergroupAddOutlined, FireOutlined, StopOutlined, CrownOutlined, MehOutlined, CopyOutlined, CoffeeOutlined, FlagOutlined, BankOutlined } from "@ant-design/icons";
import GamePicker from "./GamePicker";

export const partyGames = [
    {
        to: "/higherOrLower",
        labelKey: "games.names.higherOrLower",
        icon: <ArrowUpOutlined />,
    },
    {
        to: "/beerpong",
        labelKey: "games.names.beerpong",
        icon: <AppstoreOutlined />,
    },
    {
        to: "/rideTheBus",
        labelKey: "games.names.rideTheBus",
        icon: <StopOutlined/>,
    },
    {
        to: "/laughfool",
        labelKey: "games.names.laughfools",
        icon: <SmileOutlined />,
    },
    {
        to: "/holzfaellern",
        labelKey: "games.names.holzfaellern",
        icon: <EnvironmentOutlined />,
    },
    {
        to: "/dontDrinkAndDrive",
        labelKey: "games.names.dontDrinkAndDrive",
        icon: <CarOutlined />,
    },
    {
        to: "/quizzler",
        labelKey: "games.names.quizzduell",
        icon: <QuestionCircleOutlined />,
    },
    {
        to: "/rageCage",
        labelKey: "games.names.rageCage",
        icon: <MehOutlined />,
    },
    {
        to: "/lieing",
        labelKey: "games.names.lieing",
        icon: <FireOutlined />,
    },
    {
        to: "/shitty",
        labelKey: "games.names.shitty",
        icon: <CopyOutlined />,
    },
    {
        to: "/kingCup",
        labelKey: "games.names.kingcup",
        icon: <CrownOutlined />,
    },
    {
        to: "/hawaii",
        labelKey: "games.names.hawaii",
        icon: <EnvironmentOutlined />,
    },
    {
        to: "/flunky",
        labelKey: "games.names.flunky",
        icon: <EnvironmentOutlined />,
    },
    {
        to: "/horseRaising",
        labelKey: "games.names.horseRaising",
        icon: <FlagOutlined  />,
    },
    {
        to: "/iti",
        labelKey: "games.names.iti",
        icon: <CoffeeOutlined  />,
    },
    {
        to: "/itiEatMyAss",
        labelKey: "games.names.itiPussy",
        icon: <CoffeeOutlined />,
    },
    {
        to: "/greekTempel",
        labelKey: "games.names.greekTemple",
        icon: <BankOutlined />,
    },

];

const SaufWithYourFriends: React.FC = () => (
    <GamePicker games={partyGames} titleKey="pages.saufFriends.title" icon={<UsergroupAddOutlined />} maxWidth={850} columns={{ sm: 12, md: 8, lg: 6 }} bordered={true} playerCountKey="pages.drinkhelper.players.party" />
);

export default SaufWithYourFriends;
